import { t } from 'i18next';
import { Paragraph } from 'tamagui';

export function ExpertBadge({ color, fontSize, name }) {
  return (
    <Paragraph
      color={color || '#fff'}
      padding={1}
      fontSize={fontSize || 12}
      fontWeight={'600'}
      paddingHorizontal={8}
      marginLeft={10}
      borderWidth={1}
      borderRadius={25}
      borderColor={'$primary'}
      backgroundColor={'#368665'}
      style={{
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'fit-content',
      }}
    >
      {name}
    </Paragraph>
  );
}
